import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var AccordionContext = /*#__PURE__*/createContext({
  isExpanded: false,
  setIsExpanded: function setIsExpanded() {}
});
export var useAccordion = function useAccordion() {
  return useContext(AccordionContext);
};
export default function AccordionWrapper(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;

  var _useState = useState(isOpen),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  return /*#__PURE__*/_jsx(AccordionContext.Provider, {
    value: {
      isExpanded: isExpanded,
      setIsExpanded: setIsExpanded
    },
    children: children
  });
}